/* RESPONSIBLE TEAM: team-standalone */

import {
  CHANNEL_ZENDESK_SUNSHINE_CONVERSATION,
  CHANNEL_ZENDESK_TICKET,
} from 'embercom/lib/operator/custom-bots/constants';
import { ChannelTargetingBodyData } from '../definitions';

export default class ZendeskChannelTargetingBodyData extends ChannelTargetingBodyData {
  get addMessengerChannel() {
    return true;
  }

  get channelGroupTitleKey() {
    return 'operator.workflows.channels.groupings.zendesk';
  }

  get channels() {
    return [
      {
        value: CHANNEL_ZENDESK_TICKET,
        icon: 'zendesk',
        requiresAppStoreInstallation: false,
        channelTypeValue: 'Zendesk',
        isSetup: true,
      } as const,
      {
        value: CHANNEL_ZENDESK_SUNSHINE_CONVERSATION,
        icon: 'zendesk',
        requiresAppStoreInstallation: false,
        channelTypeValue: 'Zendesk',
        isSetup: true,
      } as const,
    ];
  }
}
